/**
 * TSQ SYNC — UAE Local Product Landing System
 * Fills in the merchant-configured promotional "viewing now" / "sold
 * recently" figures. The number shown is picked once per browser session
 * (persisted in sessionStorage keyed by the element's template text) from
 * the merchant-configured [min, max] range — it never changes on its own
 * afterwards, and it is never presented as verified analytics.
 * No external libraries, no network calls.
 */
(function () {
  function fillRandomText(el) {
    var range = (el.dataset.tsqRandomRange || '').split(',');
    var min = parseInt(range[0], 10);
    var max = parseInt(range[1], 10);
    if (isNaN(min) || isNaN(max)) return;
    if (max < min) { var tmp = min; min = max; max = tmp; }

    var template = el.dataset.tsqRandomTemplate || '';
    var storageKey = 'tsq_social_proof_' + template;
    var value;
    try {
      var stored = sessionStorage.getItem(storageKey);
      value = stored ? parseInt(stored, 10) : null;
    } catch (e) {
      value = null;
    }
    if (value === null || isNaN(value)) {
      value = Math.floor(Math.random() * (max - min + 1)) + min;
      try {
        sessionStorage.setItem(storageKey, String(value));
      } catch (e) {
        /* ignore */
      }
    }

    var textEl = el.querySelector('[data-tsq-random-text]');
    if (textEl && template) {
      textEl.textContent = template.replace('__N__', value);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tsq-random-range]').forEach(fillRandomText);
  });
})();
